// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.badge[data-v-8bb2852c] {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    z-index: 1;\n    transform: rotate(-40deg);\n    background-color: black;\n    padding: 10px 20px;\n    border-radius: 10px;\n    margin-top: calc(1em + 20px);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
